import { cookie } from '@y2/packages-utils/cookies';

import { cohortKey, domain } from './consts';

const expiresInMonths = 6;
const range = { from: 1, to: 100 };
const millisecToSec = 1000;

export const createCohortValue = () =>
  Math.floor(Math.random() * range.to) + range.from;

const getExpirationDate = () => {
  const expiresDate = new Date();
  expiresDate.setMonth(expiresDate.getMonth() + expiresInMonths);

  return expiresDate;
};

export const setCohortCookie = () => {
  const newCohort = createCohortValue();
  const expiresDate = getExpirationDate();

  cookie.set(cohortKey, newCohort, {
    maxAge: (expiresDate.getTime() - Date.now()) / millisecToSec,
    domain: domain,
    path: '/',
  });

  return newCohort;
};
